import script from "./ApiBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiBtn.vue?vue&type=script&setup=true&lang=js"

import "./ApiBtn.vue?vue&type=style&index=0&id=9b53fb96&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b53fb96"]])

export default __exports__